import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	associationRow: {
		textRendering: "optimizeLegibility !important",
		WebkitFontSmoothing: "antialiased !important",
		fontSize: "0.875rem",
		fontWeight: 400,
		lineHeight: 1.43,
		fontFamily: "\"IBM Plex Sans\",sans-serif",
		color: colors.gray[700],
		margin: 0,
		boxSizing: "inherit",
		width: "100%",
		border: `1px solid ${colors.gray[200]}`,
		padding: "16px !important",
		borderRadius: 12
	},
	associationSentence: {
		fontSize: "14.5px",
		lineHeight: 2,
		color: colors.gray[900]
	},
	inlineAutocompleteRoot: {
		display: "inline-flex",
		verticalAlign: "baseline",
		width: "auto",
		minWidth: 150
	},
	inlineSelectInput: {
		"& .MuiOutlinedInput-root": {
			border: "none",
			borderRadius: 0,
			padding: 0,
			backgroundColor: "transparent"
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none",
			borderBottom: `2px solid ${colors.blue[200]}`,
			borderRadius: 0
		},
		"& .MuiOutlinedInput-input": {
			padding: "2px 6px",
			fontWeight: 800,
			fontSize: "14.5px",
			color: colors.blue[700],
			"&::placeholder": {
				opacity: 1,
				color: colors.blue[700],
				fontWeight: 800
			}
		}
	},
	addAssociationButton: {
		fontWeight: 700,
		fontSize: "14.5px",
		color: colors.blue[700],
		textTransform: "none"
	}
}))

export default useStyles
